var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('MarksLegalsPgHeader'),_c('section',{staticClass:"form-full-width"},[_c('FormMarksLegalsPg',{attrs:{"loading":_vm.loading,"getMarksLegalsPg":_vm.getMarksLegalsPg},on:{"beforeUpdate":_vm.updateMarksLegalsPg}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }